import React from 'react';

import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { airlineMileageProgramMap } from '^/constants/airlineMileageProgram';
import { ReservationDetailed } from '^/types/ReservationDetailed/RawReservationDetailed';
import { CancellationWarningBeforePickup72Hours } from '^/pages/ReservationDetail/CancellationWarningBeforePickup72hours';
import { MustHaveBelongings } from '^/pages/Booking/renewal/components/DriverInfo/MustHaveBelongings';

export const ReservationDetailsDriverInfo: React.FC<{
  data: ReservationDetailed;
  onClickCancelReservation(reservationToCancel: ReservationDetailed, e: React.MouseEvent): void;
}> = observer(function ReservationDetailsDriverInfo({ data, onClickCancelReservation }) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-[40px]">
      <section className="flex flex-col gap-[24px]">
        <h3 className="text-semilarge font-bold">운전자 정보</h3>

        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-3">
            <p className="text-big font-bold">{t('koreanName')}</p>
            <p className="text-default font-light">{data?.korean_name || '-'}</p>
          </div>
          <div className="flex flex-col gap-3">
            <p className="text-big font-bold">{t('phone')}</p>
            <p className="text-default font-light">{`${data?.phone_code} ${data?.phone_number}`}</p>
          </div>
          <div className="flex flex-col gap-3">
            <p className="text-big font-bold">{t('lastName')}</p>
            <p className="text-default font-light">{data?.last_name || '-'}</p>
          </div>
          <div className="flex flex-col gap-3">
            <p className="text-big font-bold">{t('firstName')}</p>
            <p className="text-default font-light">{data?.first_name || '-'}</p>
          </div>
          <div className="flex flex-col gap-3">
            <p className="text-big font-bold">{t('email')}</p>
            <p className="text-default font-light">{data?.email || '-'}</p>
          </div>
        </div>
      </section>
      <section className="flex flex-col gap-[24px]">
        {data?.hertz_membership && (
          <div className="flex flex-col gap-3">
            <p className="text-semilarge font-bold ">허츠 골드 멤버십</p>
            <p className="text-big">회원번호</p>
            <p className="text-default font-light">{data.hertz_membership}</p>
          </div>
        )}

        <div className="flex flex-col gap-3">
          <p className="text-semilarge font-bold ">도착 비행기 정보</p>
          <div className="flex">
            {data.flight_brand && (
              <div className="flex basis-1/2 flex-col gap-3">
                <p className="text-big">항공사</p>
                <p className="text-default font-light">{data.flight_brand || '-'}</p>
              </div>
            )}
            <div className="flex basis-1/2 flex-col gap-3">
              <p className="text-big">항공편명 </p>
              <p className="text-default font-light">{data.flight_number || '-'}</p>
            </div>
          </div>
        </div>

        {data?.frequent_flyer && data.frequent_brand && (
          <div className="flex flex-col gap-3">
            <p className="text-semilarge font-bold ">항공 마일리지 적립</p>
            <div className="flex">
              <div className="flex basis-1/2 flex-col gap-3">
                <p className="text-big">항공 마일리지 제휴사</p>
                <p className="text-default font-light">
                  {airlineMileageProgramMap.get(data.frequent_brand)?.name || '-'}
                </p>
              </div>
              <div className="flex basis-1/2 flex-col gap-3">
                <p className="text-big">제휴사 회원번호</p>
                <p className="text-default font-light">{data.frequent_flyer || '-'}</p>
              </div>
            </div>
          </div>
        )}
      </section>
      {data.supplier === 'OR' && <MustHaveBelongings />}
      {data.res_status === 'booked' && (
        <div>
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault(); // 스크롤 상단 이동 방지
              onClickCancelReservation(data, e);
            }}
            disabled={data.cancelDisabled}
            className="
              w-full rounded-trimo-5
              bg-trimo-bg p-3
              text-center font-bold
              text-primary-gray
              hover:cursor-pointer hover:bg-primary-skyblue hover:text-white
              focus:text-white
              active:text-white
              disabled:cursor-not-allowed disabled:bg-secondary-gray disabled:text-neutral-300 "
          >
            {t('cancelBooking')}
          </button>
          <CancellationWarningBeforePickup72Hours show={data.show72HoursCancelWarning} />
        </div>
      )}
    </div>
  );
});
